import React from 'react';
import OrderServiceTableRow from './OrderServiceTableRow'
import {View, StyleSheet, Text } from '@react-pdf/renderer';
import OrderServiceTableHeader from './OrderServiceTableHeader'

const styles = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderWidth: 1,
        borderRadius:'5px',
        borderColor: '#000000 ',
    },
    reportText:{
        marginTop: 15,
        color: '#000',
        letterSpacing: 1,
        fontSize: 11
    },
});

const OrderServiceItemsTable = ({data}) => {
    const dados = (data.orderService && data.orderService?.productsAndServices.length > 0) ? data.orderService?.productsAndServices : []
    return <>
        <Text style={styles.reportText}>SERVIÇOS</Text>
        <View style={styles.tableContainer}>
            <OrderServiceTableHeader />
            <OrderServiceTableRow items={dados} />
            {/* <OrderServiceTableFooter items={data.services} /> */}
        </View>
    </>
};

export default OrderServiceItemsTable